'use strict';

var Vue = require('vue');
var Vuex = require('vuex');

Vue.use(Vuex);

module.exports = new Vuex.Store({
  state: require('./state'),
  getters: require('./getters'),
  mutations: require('./mutations'),
  actions: require('./actions')
});



//////////////////
// WEBPACK FOOTER
// ./src/scripts/application/store/index.js
// module id = 179
// module chunks = 0